<template>
    <v-form ref="form" @submit.prevent>
        <v-layout wrap>
            <v-flex xs12 md6 lg4>
                <CustomerDropdown :customer_id="sample.customer_id"  @selected="addCustomerDemographics" :rules="formRules" />
            </v-flex>
            <v-flex xs12 md6 lg4>
                <v-text-field
                        v-model="sample.manifest_id"
                        label="Manifest ID"
                        :rules="formRules">
                </v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg4>
                <v-text-field
                        label="Sample Name (Strain)"
                        v-model="sample.name"
                        :rules="formRules">
                </v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg4>
                <DropdownSampleTypes :sample_type="sampleType" @selected="addSampleType" :rules="formRules" />
            </v-flex>
            <v-flex xs12 md6 lg4>
                <v-text-field
                        label="QA #"
                        v-model="sample.qa"
                        >
                </v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg4>
                <v-text-field
                        label="Lot #"
                        v-model="sample.lot"
                        >
                </v-text-field>
            </v-flex>
            <v-flex xs6 md6 lg4>
                        <v-radio-group v-model="sample.is_rnd">
                            <v-radio label="QA" :value="false">
                            </v-radio>
                            <v-radio label="RND" :value="true"></v-radio>
                        </v-radio-group>
            </v-flex>
            <v-flex xs6 md6 lg4>
                <DropdownUnits v-show="false" ref="unit_select" @selected="addUnitUuid" :rules="formRules" />
            </v-flex>
            <v-flex xs6 md6 lg4></v-flex>
            <SampleTestSelection :sample_type="sample.sample_type_name" @selected="sample.tests = $event" />
            <v-flex xs12 md12 lg12>
                <v-btn color="success" @click="addSampleToParent" ><v-icon>{{sample_data ? 'update': 'add'}}</v-icon>{{sample_data ? 'Update sample': 'Add sample'}}</v-btn>
                <v-btn color="error" v-if="!sample_data" @click="resetForm">Reset</v-btn>
            </v-flex>

        </v-layout>
    </v-form>
</template>

<script>
    export default {
        name: "OrdersSample",
        components: {
            SampleTestSelection: () => import('./RequiredTestSelection'),
            CustomerDropdown: () => import("./CustomerDropdown"),
            DropdownSampleTypes: () => import("./DropdownSampleTypes"),
            DropdownUnits: () => import("./DropdownUnits")
        },
        data() {
            return {
                sample: {
                    manifest_id: null,
                    id: null,
                    name: null,
                    customer_id: null,
                    sample_cert_type_uuid: null,
                    sample_type_name: null,
                    legal_type: null,
                    qa: null,
                    lot: null,
                    is_rnd: false,
                    harvest_date: null,
                    weight: 0,
                    unit_uuid: null,
                    unitName: null,
                    salt: null,
                    created_by: null,
                    tests: [],

                },
                formRules: [v => !!v || 'This is a required field'],
                //controls if passed manifest sample sets.
                sampleProgress: null,
                sampleType: null,
            }
        },
        props:{
            sample_data: {
                default:null
            }
        },
        created() {
            this.addUserId();
            // if(this.samples){
            //     this.sampleProgress = 0;
            //     this.buildSample()
            // }
        },
        watch:{
          sample_data:{
              deep: true,
              handler(v, oldValue){
                  this.buildSample()

              }
          },
        },
        computed:{
            progress(){
                return ((this.sampleProgress*1+1) / this.samples.length) *100
            }
        },
        methods: {
            buildSample(){
                // if(this.sampleProgress === null)return;
                let sample = this.sample_data;
                this.sample.manifest_id = sample.global_inventory_transfer_id ? sample.global_inventory_transfer_id : sample.manifest_id;
                this.sample.customer_id = sample.customer_id;
                this.sample.name = sample.strain_name ? sample.strain_name : sample.name;
                this.sampleType = sample.type ? sample.type : "Flower";
                this.sample.legal_type = sample.intermediate_type ? sample.intermediate_type : sample.legal_type;
                this.sample.qa = sample.global_inventory_id ? sample.global_inventory_id : sample.qa;
                this.sample.lot = sample.global_id ? sample.global_id : sample.lot;
                this.sample.weight = sample.qty ? sample.qty : sample.weight;
            },
            addUserId() {
                this.sample.created_by = this.$store.id
            },
            addSampleType(selectedSampleType) {
                if(selectedSampleType){
                    this.sample.sample_cert_type_uuid = selectedSampleType.uuid
                    this.sample.sample_type_name = selectedSampleType.name
                }
            },
            addUnitUuid(selectedUnitUuid) {
                this.sample.unit_uuid = selectedUnitUuid.uuid;
                this.sample.unitName = selectedUnitUuid.name;
            },
            addCustomerDemographics(customerObject) {
                this.sample.customer_id=customerObject.customer_id;
                this.sample.customerName=customerObject.name;
            },
            addSampleToParent() {
                if(this.$refs.form.validate()){
                    if(!this.sample.unit_uuid){
                        this.addUnitUuid(this.$refs.unit_select.unit)
                    }
                    this.$emit('newsample', this.sample);
                    if(!this.sample_data){
                        this.resetForm();
                    }
                }
            },
            addTest() {
                this.sample.tests.push({
                    test: null,
                })
            },
            removeTest(index){
                this.sample.tests.splice(index,1)
            },
            resetForm() {
                // this.sample.manifest_id = null
                this.sample.id = null;
                this.sample.name = null;
                // this.sample.customer_id = null;
                this.sample.legal_type = null;
                this.sample.qa = null;
                this.sample.lot = null;
                this.sample.harvest_date = null;
                // this.sample.weight = null;
                // this.sample.unit_uuid = null;
                this.sample.salt = null;
            }
        },
        mounted(){
            if(this.sample_data){
                this.buildSample();
            }
        },
    }
</script>

<style scoped>

</style>
